import { callApi } from "./api";

export const fetchCurrentUser = () => {
  return callApi("currentuser?_format=json").then((response) => {
    if (response.response && response.response.length) {
      return { response: response.response };
    } else {
      return { response: {} };
    }
  });
};

export const login = (payload) => {
  const body = { name: payload.email, pass: payload.password };
  const params = {
    method: "POST",
    headers: { Accept: "application/json" },
    body: JSON.stringify(body),
  };

  return callApi("user/login?_format=json", params).then((response) => {
    if (response.response && response.response.current_user) {
      return { response: response.response };
    } else {
      return { error: response.error };
    }
  });
};

export const register = (payload) => {
  const body = {
    field_first_name: [payload.firstname],
    field_last_name: [payload.lastname],
    name: [payload.email],
    mail: [payload.email],
    pass: [payload.password],
  };
  const params = {
    method: "POST",
    headers: { Accept: "application/json" },
    body: JSON.stringify(body),
  };

  return callApi("user/register?_format=json", params).then((response) => {
    if (response.response) {
      return { response: response.response };
    } else {
      return { error: response.error };
    }
  });
};

export const logout = () => {
  return callApi("user/logout?_format=json").then((response) => {
    if (response.response && response.response.length) {
      return { response: response.response };
    } else {
      return { response: {} };
    }
  });
};
